<template>
  <v-container
    class="video-background-wrapper"
    :class="{ mask: options.gradient }"
    fluid
    :style="
      options.background
        ? {
            'background-image':
              'url(' +
              require('@/assets/images/homepage/' + options.background) +
              ')',
          }
        : ''
    "
  >
    <video
      class="video-bg"
      preload="auto"
      loop=""
      autoplay=""
      muted=""
      playsinline=""
      :poster="options.backgroundVideoFiles.thumb"
    >
      <source type="video/webm" :src="options.backgroundVideoFiles.webm" />
      <source type="video/mp4" :src="options.backgroundVideoFiles.mp4" />
      <source type="video/ogv" :src="options.backgroundVideoFiles.ogv" />
    </video>
    <v-row>
      <v-col class="col-12 col-md-7 pa-md-0" offset-md="1">
        <h1 v-html="options.title"></h1>
        <h5 v-html="options.subtitle"></h5>
      </v-col>
      <v-col class="col-12 col-md-2 pa-md-0 video-button-wrapper" offset-md="1">
        <a
          data-fancybox="video"
          :href="`https://www.youtube.com/watch?v=${options.videoId}&amp;rel=0&amp;autoplay=1`"
          class="video-wrapper"
        >
          <span class="bar"></span>
          <v-img
            contain
            width="66px"
            :src="require('@/assets/images/homepage/' + options.playButtonBg)"
            class="play-button"
          />
        </a>
        <p class="hightlight" v-html="options.hightlightText"></p>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

export default {
  name: 'HeroVideoBackgroundComponent',
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  mounted() {
    // Fancybox init
    Fancybox.bind('[data-fancybox]', {});
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.video-background-wrapper
  background-repeat: no-repeat
  background-size: cover
  background-position: center top
  display: flex
  justify-content: flex-start
  align-items: center
  position: relative
  min-height: 795px
  &.mask
    &:after
      background: linear-gradient(180deg, rgba(0, 48, 54, 0.0001) 0%, #003036 100%)
      content: ""
      position: absolute
      display: block
      width: 100%
      height: 100%
      top: 0
      left: 0
      z-index: 1
  .col
    z-index: 2
  .video-bg
    position: absolute
    display: block
    left: 0
    top: 0
    width: 100%
    height: 100%
    object-fit: cover
  h1,
  h5
    color: #ffffff
  h1
    font-family: 'metropolissemi_bold'
    font-weight: 600
    font-size: 72px
    line-height: 1.2
    margin-bottom: 30px
  h5
    font-family: 'metropolisregular'
    font-weight: 400
    font-size: 18px
    line-height: 1.4
    margin: 0
    ::v-deep
      span
        font-family: 'metropolisbold'
        font-weight: 700
  .video-button-wrapper
    display: flex
    justify-content: center
    align-items: center
    flex-direction: column
    .video-wrapper
      position: relative
      display: block
      width: 183px
      height: 183px
      margin-bottom: 35px
      &:hover
        &:before
          transform: translate(-50%, -50%) rotate(90deg)
        &:after
          transform: translate(-50%, -50%) rotate(360deg)
        .bar
          transform: translate(-50%, -50%) rotate(540deg)
      &:before,
      &:after,
      .bar
        content: ""
        position: absolute
        display: block
        border: 2px solid transparent
        border-right-color: #ffffff
        border-top-color: #ffffff
        border-bottom-color: #ffffff
        border-radius: 50%
        top: 50%
        left: 50%
        transition: all 1s
        transform: translate(-50%, -50%)
      &:before
        width: 109px
        height: 109px
      &:after
        width: 149px
        height: 149px
        transform: translate(-50%, -50%) rotate(240deg)
      .bar
        width: 182px
        height: 182px
        transform: translate(-50%, -50%) rotate(360deg)
      .play-button
        position: absolute
        display: block
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)
    .hightlight
      background: rgba(255,255,255, 0.3)
      font-family: 'metropolisregular'
      font-weight: 400
      font-size: 16px
      color: #ffffff
      line-height: 1.5
      text-transform: uppercase
      padding: 9px 15px
      margin: 0
      border-radius: 20px
      ::v-deep
        span
          background: #26D07C
          font-family: 'metropolissemi_bold'
          font-weight: 600
          font-size: 14px
          color: #003036
          padding: 4px 12px
          border-radius: 20px
  @media screen and (max-width: 1750px)
    h1,
    h5
      max-width: 850px
  @media screen and (max-width: 959px)
    min-height: 600px
    > .row
      flex-flow: column-reverse
    h1
      font-size: 20px
    h5
      font-size: 16px
      line-height: 1.4
    .video-button-wrapper
      align-items: flex-start
      .video-wrapper
        width: 115px
        height: 115px
        margin-left: 20%
        &:before
          width: 68px
          height: 68px
        &:after
          width: 93px
          height: 93px
        .bar
          width: 114px
          height: 114px
        .play-button
          width: 41px !important
</style>
